/*
 * fn: recordFromArray
 *
 * Gets an object record from an array of tuples
 *
 */
export const recordFromArray = <T, K extends PropertyKey, V>(
  list: readonly T[],
  fn: (item: T) => readonly [K, V],
): Record<K, V> => {
  const record = {} as Record<K, V>
  for (const item of list) {
    const [key, value] = fn(item)
    record[key] = value
  }
  return record
}
